import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './style.less';

const container = document.querySelector('#gloading');

function unmount(c) {
  // const unmountResult = ReactDOM.unmountComponentAtNode(container)
  // console.log(container,'---->',unmountResult);
  // if (unmountResult && container.parentNode) {
  //   container.parentNode.removeChild(container)
  // }
  c.innerHTML = '';
}

export function show() {
  const TempToast = () => {
    return (
      <div id="l-c">
        <img className="img-loading" src={`/assets/imgs/loading.gif`} />
      </div>
    );
  };
  ReactDOM.render(<TempToast />, container);
}

export function clear() {
  unmount(document.getElementById('l-c'));
}

const Loading = {
  show,
  clear
};

export default Loading;



// WEBPACK FOOTER //
// ./src/pubBiz/Loading/index.js